import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components/dc-icon';

export enum HdIcons {
	LineChart = 'Handle:chart-line',
	PieChart = 'Handle:chart-pie',
	BarChart = 'Handle:chart-bar',
	AreaChart = 'Handle:chart-area',
	FunnelChart = 'Handle:chart-funnel',
	GaugeBarChart = 'Handle:chart-gauge-bar',
	GaugeCircularChart = 'Handle:chart-gauge-circular',
	GaugeLinearChart = 'Handle:chart-gauge-linear',
	IndicatorChart = 'Handle:chart-indicator',
	RangeChart = 'Handle:chart-range',
	SankeyChart = 'Handle:chart-sankey',
	ScatterChart = 'Handle:chart-scatter',
	TreemapChart = 'Handle:chart-treemap',
	Dashboard = 'Handle:dashboard',
	Media = 'Handle:media',
	Map = 'Handle:map',
	Timeline = 'Handle:timeline',
	Chart = 'Handle:chart',
	Grid = 'Handle:Grid',
	GridSimple = 'Handle:Grid-simple',
	GridPivot = 'Handle:Grid-pivot',
}

@Injectable()
export class AppHdIcons extends AppIcons {
	private readonly path = './src/img';
	protected namespace = 'Handle';

	protected icons: IIcons = {
		[HdIcons.LineChart]: `${this.path}/hd/chart-line-solid.svg`,
		[HdIcons.PieChart]: `${this.path}/hd/chart-pie-solid.svg`,
		[HdIcons.BarChart]: `${this.path}/hd/chart-bar-solid.svg`,
		[HdIcons.AreaChart]: `${this.path}/hd/chart-area-solid.svg`,
		[HdIcons.FunnelChart]: `${this.path}/hd/chart-funnel-solid.svg`,
		[HdIcons.GaugeBarChart]: `${this.path}/hd/chart-gauge-bar-solid.svg`,
		[HdIcons.GaugeCircularChart]: `${this.path}/hd/chart-gauge-circular-solid.svg`,
		[HdIcons.GaugeLinearChart]: `${this.path}/hd/chart-gauge-linear-solid.svg`,
		[HdIcons.IndicatorChart]: `${this.path}/hd/chart-indicator-solid.svg`,
		[HdIcons.RangeChart]: `${this.path}/hd/chart-range-solid.svg`,
		[HdIcons.SankeyChart]: `${this.path}/hd/chart-sankey-solid.svg`,
		[HdIcons.ScatterChart]: `${this.path}/hd/chart-scatter-solid.svg`,
		[HdIcons.TreemapChart]: `${this.path}/hd/chart-treemap-solid.svg`,

		[HdIcons.Dashboard]: `${this.path}/hd/dc-dashboard-solid.svg`,
		[HdIcons.Media]: `${this.path}/hd/dc-media-solid.svg`,
		[HdIcons.Map]: `${this.path}/hd/dc-map-solid.svg`,
		[HdIcons.Timeline]: `${this.path}/hd/dc-timeline-solid.svg`,
		[HdIcons.Chart]: `${this.path}/hd/dc-chart-solid.svg`,
		[HdIcons.Grid]: `${this.path}/hd/dc-grid-solid.svg`,
		[HdIcons.GridSimple]: `${this.path}/hd/dc-grid-simple.svg`,
		[HdIcons.GridPivot]: `${this.path}/hd/dc-grid-pivot.svg`,
	};
}
